import type { Part, PartBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<Part, PartBase>({
  tableName: "parts",
  viewName: "parts_enriched",
  searchColumns: ["name", "sku"],
  computedColumns: ["locationName", "vendorName"],
});

export class PartService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static createMany = base.createMany;
  static update = base.update;
  static delete = base.delete;
}
